import { SVGInterface } from "../../interface";

const VolumeMute = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M14.5 8.83V15.17L12.33 13H9.5V11H12.33L14.5 8.83ZM16.5 4L11.5 9H7.5V15H11.5L16.5 20V4Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default VolumeMute;
